<template>
  <div class="list-page__container">
    <v-sheet v-if="hasItems" class="list-page-grid" rounded>
      <div class="list-page-grid__wrapper">
        <v-row v-if="isLoading" class="product-list">
          <v-col v-for="n in 20" :key="n" class="product-list__col" cols="12" md="3" sm="6">
            <div class="product__box">
              <v-skeleton-loader class="mx-auto" max-width="300" type="image, list-item-three-line" />
            </div>
          </v-col>
        </v-row>

        <v-row v-else class="product-list">
          <template v-if="isBranchCardMode">
            <v-col v-for="branch in branches" :key="branch.bid" class="product-list__col" cols="12" md="3" sm="6">
              <div class="product__box">
                <branch-card :branch="branch" :bring-query="false" />
              </div>
            </v-col>
          </template>

          <template v-else>
            <v-col v-for="product in products" :key="product.product_id" class="product-list__col" cols="12" md="3" sm="6">
              <div class="product__box">
                <product-card :product="product" :bring-query="false" />
              </div>
            </v-col>
          </template>
        </v-row>

        <loading v-if="isLoading" class="list-loading" :width="72" :height="72" color="orange" />
      </div>

      <slot name="footer" />
    </v-sheet>

    <div v-else class="list-page-grid--empty">
      <p class="empty-text">{{ $t('filter_empty_message') }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
interface BranchItem {
  bid: number | string
  [key: string]: unknown
}

interface ProductItem {
  product_id: number | string
  [key: string]: unknown
}

interface Props {
  cardMode?: string
  branches?: BranchItem[]
  products?: ProductItem[]
  isLoading?: boolean
}

const ProductCard = defineAsyncComponent(() => import('@/components/card/product.vue'))
const BranchCard = defineAsyncComponent(() => import('@/components/card/BranchCard.vue'))
const Loading = defineAsyncComponent(() => import('@/components/icons/loading.vue'))

const props = withDefaults(defineProps<Props>(), {
  cardMode: 'branch',
  branches: () => [],
  products: () => [],
  isLoading: false,
})

const isBranchCardMode = computed(() => props.cardMode === 'branch')
const hasItems = computed(() => (isBranchCardMode.value ? props.branches.length > 0 : props.products.length > 0))
</script>

<style scoped lang="scss" src="@/assets/sass/pages/categories.scss"></style>
